import { createFileRoute } from '@tanstack/react-router';
import { InvoicePage } from '@/features/invoices/components/InvoicePage';

export const Route = createFileRoute('/$commiteeSlug/invoices/$invoiceId')({
  component: InvoicePage,
});
